jQuery(document).ready(function() {
    jQuery('.sid-modal-open').click(function() {
        jQuery('.sid-modal .sid-wrapper').append('<iframe src="'+ jQuery(this).attr('pdf-url') +'">Loading...</iframe>');
        jQuery('.sid-modal').css('display','flex');
        jQuery('.sid-wrapper').fadeIn(300);
    });
    jQuery('.sid-modal-close').click(function() {
        jQuery('.sid-modal').fadeOut(300, function(){
            // jQuery('.sid-wrapper').css('display','none');
            jQuery('.sid-wrapper').find('iframe').remove();
        });
    });


    jQuery(document).on('click',".sid-modal-design-action",function(){
		
		jQuery("#sid-save-design").css('display','flex');
		let saveAction = jQuery(this);

		var fd_cd_id = 0;

		if(saveAction.attr('data-type') == 'viewcustomdesign'){
			fd_cd_id = saveAction.attr('data-id');
		} else if(saveAction.attr('data-type') == 'deletecustomdesign'){
			fd_cd_id = saveAction.attr('data-id');
			if(saveAction.text() == 'Delete'){
				saveAction.text('Are you sure?');
				return true;
			}

		}
		
		// var saveBtnText = saveAction.text();
		// saveAction.css('pointer-events', 'none');
		// saveAction.text('Please wait...');
		

		jQuery.ajax({
			url: fd_ajax.ajax_url,
			type: "POST",
			dataType: "json",
			data: { 
				action : "fd_save_custom_design",
				type: saveAction.attr('data-type'),
				fd_cd_id: fd_cd_id,
				nonce: fd_ajax.nonce},
			success: function(response){
				// saveAction.removeAttr('style');
				// saveAction.text(saveBtnText);

                if (saveAction.attr('data-type') == 'viewcustomdesign') {
                    jQuery('#sid-account-image-view').css('display', 'flex');
					jQuery('#sid-account-image-view .sid-wrapper img').remove();
					jQuery('#sid-account-image-view .sid-wrapper').append('<img src="'+ response.content +'">');
                } else if (saveAction.attr('data-type') == 'deletecustomdesign') {
					jQuery("#cd-row-" + response.content).remove();					
				}
			},
			error: function(error){
				saveAction.removeAttr('style');
				saveAction.text(saveBtnText);
			}
		});

	});


  });